export const getInitState = skillsArray =>
  skillsArray.reduce((acc, key, index) => ({ ...acc, [key]: index < 2 }), {})

export const getToggledState = (skillsArray, allReviewsOpen) =>
  skillsArray.reduce((acc, key) => ({ ...acc, [key]: !allReviewsOpen }), {})
